import { formatBooleanValue } from "../..";
import ReportingPeriodApplicantDocument, {
  IReportingPeriodApplicantDocument
} from "../../model/document/ReportingPeriodApplicantDocument";
import { IHttpService, FileParam } from "../HttpService";

export interface IReportingPeriodApplicantDocumentService {
  getReportingPeriodApplicantDocuments(
    reportingPeriodApplicantId: number
  ): Promise<IReportingPeriodApplicantDocument[]>;
  assignReportingPeriodApplicantDocument(
    reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
  ): Promise<void>;
  removeReportingPeriodApplicantDocument(
    reportingPeriodApplicantId: number,
    documentId: number
  ): Promise<void>;
  uploadDocument(document: any): Promise<number>;
  updateDocument(documentId: number, document: any): Promise<any>;
  getAllowedFileTypes(): Promise<string | undefined>;
}

const ReportingPeriodApplicantDocumentService = (
  httpService
): IReportingPeriodApplicantDocumentService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api";
  const _documentsPath: string = "/documents";
  const _reportingPeriodApplicantPath: string = "/reporting-period-applicants";
  const _allowedFileTypes: string = "/allowed-file-types";

  const reportingPeriodApplicantDocumentsListMapper = (
    json = []
  ): IReportingPeriodApplicantDocument[] => {
    return json.map((item: any) => {
      let reportingPeriodApplicantDocument =
        ReportingPeriodApplicantDocument(item);
      reportingPeriodApplicantDocument.valid = formatBooleanValue(item.valid);
      return reportingPeriodApplicantDocument;
    });
  };

  return {
    async getReportingPeriodApplicantDocuments(
      reportingPeriodApplicantId: number
    ) {
      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        _reportingPeriodApplicantPath,
        reportingPeriodApplicantId.toString()
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return reportingPeriodApplicantDocumentsListMapper(responseJSON);
    },

    async assignReportingPeriodApplicantDocument(
      reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
    ) {
      const reportingPeriodApplicantId =
        reportingPeriodApplicantDocument.reportingPeriodApplicantId;
      const documentId = reportingPeriodApplicantDocument.documentId;

      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        _reportingPeriodApplicantPath,
        reportingPeriodApplicantId.toString(),
        _documentsPath,
        documentId.toString()
      );
      await _http.post(path, {
        params: reportingPeriodApplicantDocument
      });
    },

    async removeReportingPeriodApplicantDocument(
      reportingPeriodApplicantId: number,
      documentId: number
    ) {
      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        _reportingPeriodApplicantPath,
        reportingPeriodApplicantId.toString(),
        _documentsPath,
        documentId.toString()
      );
      await _http.remove(path);
    },
    async uploadDocument(document: any) {
      const path = _http.buildPath(_basePath, _documentsPath);
      const fileParams: FileParam[] = [];
      const response = await _http.uploadFile(
        path,
        document,
        "document",
        fileParams
      );
      const responseJSON = await _http.toJSON(response);
      return Number(responseJSON);
    },

    async updateDocument(documentId: number, document: any) {
      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        documentId.toString()
      );
      const fileParams: FileParam[] = [
        { key: "documentId", value: documentId }
      ];
      const response = await _http.uploadFile(
        path,
        document,
        "document",
        fileParams
      );
      return _http.toText(response);
    },

    async getAllowedFileTypes() {
      const path = _http.buildPath(
        _basePath,
        _documentsPath,
        _allowedFileTypes
      );
      const response = await _http.get(path);
      return _http.toText(response);
    }
  };
};

export default ReportingPeriodApplicantDocumentService;
